import { render, staticRenderFns } from "./user_management.vue?vue&type=template&id=d95faf68&scoped=true"
import script from "./user_management.vue?vue&type=script&lang=js"
export * from "./user_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95faf68",
  null
  
)

export default component.exports